import { Box, Tooltip as MUITooltip, TooltipProps } from '@mui/material';
import { ReactNode } from 'react';

interface InfoTooltipProps {
  label?: ReactNode;
  title: ReactNode;
  bgColor?: string;
  placement?: TooltipProps['placement'];
  children: any;
}

export default function Tooltip({ label, title, placement = 'top', children, bgColor = 'black' }: InfoTooltipProps) {
  return (
    <Box display='flex' flexDirection='row' alignItems='center' gap={0.5}>
      {label}
      <MUITooltip
        title={title}
        placement={placement}
        arrow
        componentsProps={{
          tooltip: {
            sx: {
              bgcolor: bgColor,
              color: 'white',
              boxShadow: 3,
              fontSize: '0.85rem',
              borderRadius: 1,
              p: 1,
              lineHeight: 1.2
            }
          },
          arrow: {
            sx: { color: bgColor }
          }
        }}
      >
        <span>{children}</span>
      </MUITooltip>
    </Box>
  );
}
